<template>
    <div class="page page-sample">
        <div class="page--main">
            <h1>Current Viewport</h1>
            width: <span v-text="width"/><br>
            height: <span v-text="height"/><br>
            mq: <span v-text="mq.query"/>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        computed: {
            ...mapState('viewport', ['width', 'height', 'mq']),
        },
    };
</script>
